module.exports = __webpack_public_path__ + "img/bancontact.0ad18a74.svg";